export class Equipment {
    constructor({
        id = null,
        code = ``,
        name = ``,
        type = ``,
        model = ``,
        spec = ``,
        desc = ``,
        area = ``,
        manu = ``,        
        active = ``,
        status = ``,
        faultTime = ''
    } = {}) {
        this.id = id;
        this.code = code;
        this.name = name;
        this.type = type;
        this.model = model;
        this.spec = spec;
        this.desc = desc;
        this.area = area;
        this.manu = manu;        
        this.active = active;
        this.status = status;
        this.faultTime = faultTime;
    }
}
export function gridFields() {
    return Object.freeze([{
            key: 'id',
            label: 'lbl.basic.id',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'code',
            label: 'lbl.basic.code',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'name',
            label: 'lbl.basic.name',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'type',
            label: 'lbl.basic.type',
            sortable: true,
            form: {
                type: 'select',
                options:[
                    { value: null, text: '' },
                    { value: 'T', text: '堆料小车' },
                    { value: 'R', text: '取料机' },
                    { value: 'S', text: '堆取料机' }
                ]
            }
        },
        {
            key: 'model',
            label: 'lbl.equipment.mode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'spec',
            label: 'lbl.equipment.spec',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'area',
            label: 'lbl.basic.area',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'manu',
            label: 'lbl.equipment.manu',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'active',
            label: 'lbl.basic.active',
            sortable: true,
            form: {
                type: 'boolean'
            }
        },
        {
            key: 'status',
            label: 'lbl.basic.status',
            sortable: true,
            form: {
                type: 'select',
                options:[
                    { value: null, text: '' },
                    { value: 'r', text: '运行中' },
                    { value: 'f', text: '故障' },
                    { value: 'e', text: '检修' }
                ]
            }
        },
        {
            key: 'faultTime',
            label: 'lbl.equipment.faultTime',
            sortable: true,
            form: {
                type: 'input'
            }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new Equipment()).map(i => 'entity.' + i));

export const filterFields = [
    'filter.nameFilter',
    'filter.codeFilter',
    'filter.typeFilter',
    'filter.areaFilter',
    'filter.activeFilter',
    'filter.statusFilter'
];

export const filter = {
    'nameFilter': "",
    'codeFilter': "",
    'typeFilter': "",
    'areaFilter': "",
    'activeFilter': "",
    'statusFilter': ""
};